<template>
  <div>
    <a-spin tip="Your document is being processed, do not leave this page!" :spinning="loading.page">
      <a-config-provider :locale="getLocalConfigProvider()">
        <div class="wrapper">
          <div class="wrapper-header">
            <span>
              <a-icon type="pic-center" class="margin-right-small" />
              Master Cost Pool
            </span>
            <a-button-group>
              <a-button type="primary" @click="handletoCreate('Create', null)" icon="plus"
                :loading="loading.create">Create</a-button>
              <a-button @click="handleReload('table')" icon="reload"></a-button>
            </a-button-group>
          </div>
          <div class="wrapper-body">
            <a-card>
              <a-tabs class="custom-tabs" :activeKey="activetab" @change="handleTab">
                <a-tab-pane style="margin: auto" key="cost_pool_list">
                  <template slot="tab">
                    <span>Cost Pool List</span>
                    <!-- <a-badge class="m-badge m-badge-small" :count="list_process.length" :numberStyle="{ backgroundColor: 'red' }"
                      v-if="list_process.length > 0">
                    </a-badge> -->
                  </template>
                  <div v-if="getScreen" class="margin-top" style="display:flex">
                    <a-input-search v-model="search" @change="moresearch" placeholder="Quick Search"
                      class="margin-right" />
                  </div>
                  <a-row :gutter="12" class="margin-top" v-else>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                      <a-input-search v-model="search" @change="moresearch" placeholder="Quick Search" />
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 0 }">
                      <div style="width:100%;text-align:right">
                        <!-- <a-badge :dot="showbadge">
                        <a-button
                          :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
                          @click="handleshowMore"
                          class="m-width-full"
                          :class="getScreen ? 'margin-top m-width-full' : 'm-width-full'"
                          >{{
                            advancedsearch == "display:none" ? "More" : "Less"
                          }}</a-button
                        >
                      </a-badge> -->
                      </div>
                    </a-col>
                  </a-row>
                  <a-table :rowKey="(record, index) => { return index.toString(); }" size="small" bordered
                    :scroll="{ x: 600 }" :columns="columns" :dataSource="resources" :loading="loading.table"
                    :pagination="pagination" class="margin-top">

                    <template slot="nomor" slot-scope="text, data, index">
                      <span>{{
                        (pagination.page - 1) * pagination.pageSize + index + 1
                      }}</span>
                    </template>
                    <template slot="kode" slot-scope="data">
                      {{ data.cost_pool_code }}
                    </template>
                    <template slot="nama" slot-scope="data">
                      {{ data.cost_pool_nm }}
                    </template>
                    <template slot="category" slot-scope="data">
                      {{ data.category_name }}
                    </template>
                    <template slot="group" slot-scope="data">
                      {{ data.group_name }}
                    </template>
                    <template slot="createby" slot-scope="data">
                      {{ data.tlc_create }}
                    </template>
                    <template slot="note" slot-scope="data">
                      {{ data.note }}
                    </template>
                    <template slot="action" slot-scope="data">
                      <a-button-group>
                        <a-button icon="edit" @click="handletoCreate('Edit', data.cost_pool_id)"
                          :loading="loading.key == data.cost_pool_id && loading.edit"></a-button>
                        <a-button icon="close" type="danger" @click="handletoDel(data.cost_pool_id)"
                          :loading="loading.key == data.cost_pool_id && loading.delete"></a-button>
                      </a-button-group>
                    </template>
                  </a-table>
                </a-tab-pane>
              </a-tabs>
            </a-card>
          </div>
        </div>
      </a-config-provider>
    </a-spin>

    <a-modal v-if="modal.edit" v-model="modal.edit" :maskClosable="false" @cancel="handleMeditClose" @ok="handleMeditOk"
      okText="Submit" cancelText="Cancel">
      <template slot="title">
        Edit Status
        <span class="snonaktif" v-if="modal.source.status == '0'">NON ACTIVE</span>
        <span class="saktif" v-else>ACTIVE</span>
        to
        <span class="snonaktif" v-if="modal.source.status == '1'">NON ACTIVE</span>
        <span class="saktif" v-else>ACTIVE</span>
      </template>
      <a-form-model ref="editStsForm" :model="formEditSts" :rules="modal.rules">
        <a-form-model-item ref="note" label="Note" prop="note">
          <a-textarea v-model="formEditSts.note" @blur="() => {
            $refs.note.onFieldBlur();
          }
            " />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-if="modal.create" v-model="modal.create" :maskClosable="false" @cancel="handleMcreateClose"
      @ok="handleMcreateOk" okText="Submit" cancelText="Cancel" :confirmLoading="loading.savecreate">
      <template slot="title">{{ modal.source.mode }} Cost Pool</template>
      <a-form :form="formCreate">
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
            <span class="ant-form-item-required">Category :</span>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 19 }">
            <a-form-item>
              <v-select class="m-select" :clearable="false" @input="inputVselect" :options="masterdata.category"
                v-decorator="['category', { rules: [{ required: true }], initialValue: modal.source.data.optionPrn }]"
                label="text"></v-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
            <span class="ant-form-item-required">Code :</span>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 19 }">
            <a-row :gutter="12">
              <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
                <a-form-item>
                  <a-input autocomplete="off"
                    v-decorator="['code2', { rules: [{ required: true }], initialValue: modal.source.data.category_code }]"
                    disabled></a-input>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item>
                  <a-input autocomplete="off"
                    v-decorator="['code', { rules: [{ required: true }], initialValue: modal.source.data.cost_pool_code }]"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="modal.source.category == 'TLC'">
          <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
            <span class="ant-form-item-required">TLC :</span>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 19 }">
            <a-form-item>
              <a-select showSearch
                v-decorator="['name', { rules: [{ required: true }], initialValue: modal.source.data.nama }]"
                :filter-option="filterOption">
                <a-select-option v-for="item in masterdata.karyawan" :key="item.tlc">{{ item.tlc }} - {{ item.nama
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-else>
          <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
            <span class="ant-form-item-required">Name :</span>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 19 }">
            <a-form-item>
              <a-input autocomplete="off"
                v-decorator="['name', { rules: [{ required: true }], initialValue: modal.source.data.nama }]"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
            Note :
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 19 }">
            <a-form-item>
              <a-textarea placeholder="Write the note here ... " :rows="4" v-decorator="['note',
                {
                  rules: [{ required: false }],
                  initialValue: modal.source.data.note,
                },]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod";
import _ from "lodash";
export default {
  name: "Createmasterdata",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      loading: {
        page: false,
        table: false,
        create: false,
        edit: false,
        key: "",
        savecreate: false,
      },
      search: "",
      resources: [],
      resourcesOri: [],
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      columns: [
        {
          title: "#",
          key: "nomor",
          align: "right",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "Code",
          key: "kode",
          align: "left",
          scopedSlots: { customRender: "kode" },
          width: 200,
        },
        {
          title: "Name",
          key: "nama",
          align: "left",
          scopedSlots: { customRender: "nama" },
          width: 250,
        },
        {
          title: "Category",
          key: "category",
          align: "left",
          scopedSlots: { customRender: "category" },
          width: 250,
        },
        {
          title: "Group",
          key: "group",
          align: "left",
          scopedSlots: { customRender: "group" },
          width: 250,
        },
        {
          title: "Create by",
          key: "createby",
          align: "center",
          scopedSlots: { customRender: "createby" },
          width: 150,
        },
        {
          title: "Note",
          key: "note",
          align: "left",
          scopedSlots: { customRender: "note" },
          width: 250,
        },
        {
          title: "Action",
          key: "action",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
          width: 100,
        },
      ],
      modal: {
        edit: false,
        create: false,
        source: {
          status: false,
          key: "",
          mode: "",
          category: "nonTLC",
          data: [],
        },
        rules: {
          note: [
            {
              required: true,
              message: "Please input Note",
              trigger: "blur",
            },
          ],
        }
      },
      formEditSts: {
        note: ""
      },
      masterdata: {
        group: [{
          id: "1",
          nama: "jos gan",
        }],
      },
      activetab: "cost_pool_list",

    };
  },
  beforeCreate() {
    this.formCreate = this.$form.createForm(this);
  },
  mounted() {
    this.handleReload('page')
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
  },
  methods: {
    async handleReload(type) {
      if (type == "page") {
        this.loading.page = true;
      } else {
        this.loading.table = true;
      }
      await this.asyncAxiosGet("akuntansi/master_cost_pool", this.getAuth, null)
        .then((res) => {
          this.resources = res.data
          for (let i = 0; i < res.data.length; i++) {
            this.resources[i]['Qsearch'] =
              res.data[i].category_code + " " +
              res.data[i].cost_pool_nm + " " +
              res.data[i].category_name + " " +
              res.data[i].group_name + " " +
              res.data[i].note + " " +
              res.data[i].tlc_create;
          }
          this.resourcesOri = this.resources

          this.loading.page = false;
          this.loading.table = false;
        })
        .catch(() => {
          this.loading.page = false;
          this.loading.table = false;
        });
    },
    handleReloadpage() {
      this.search = ""
      this.handleReload('table')
    },
    async getMasterData() {
      await this.asyncAxiosGet("akuntansi/master_cost_pool/master", this.getAuth, null)
        .then((res) => {
          this.masterdata = res
        })
        .catch(() => {
        });
    },
    moresearch() {
      if (this.search) {
        this.resources = _.filter(this.resourcesOri, (e) =>
          e.Qsearch.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
      } else {
        this.resources = this.resourcesOri
      }
    },
    handletoEdit(key, status) {
      this.modal.source.status = status
      this.modal.source.key = key
      this.modal.edit = true;
    },
    handleMeditClose() {
      this.modal.edit = false;
    },
    handleMeditOk() {
      this.$refs.editStsForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        let idx = _.findIndex(this.resources, (e) => e.key == this.modal.source.key)
        this.resources[idx]._active = (this.modal.source.status == "1" ? "0" : "1")
        this.$refs.editStsForm.resetFields()
        this.modal.edit = false;
      })
    },
    handletoCreate(mode, key) {
      if (mode == "Create") {
        this.loading.create = true
      } else {
        this.loading.edit = true
        this.loading.key = key
      }
      this.getMasterData().then(() => {
        this.modal.source.mode = mode
        if (mode == "Edit") {
          this.getMasterData().then(() => {
            this.asyncAxiosGet("akuntansi/master_cost_pool", this.getAuth, { cost_pool_id: key })
              .then((res) => {
                this.modal.source.data = res.data[0]
                this.modal.source.data.cost_pool_code = this.modal.source.data.cost_pool_code.substring(this.modal.source.data.category_code.length + 1, this.modal.source.data.cost_pool_code.length)
                let prn = _.filter(this.masterdata.category, (e) => e.cost_pool_category_id == res.data[0].cost_pool_category_id)
                this.modal.source.data.optionPrn = prn[0]

                this.modal.source.category = "nonTLC"
                if (res.data[0].category_name == 'TLC')
                  this.modal.source.category = "TLC"

                this.loading.create = false
                this.loading.edit = false
                this.loading.key = ""
                this.modal.create = true;
              })
              .catch(() => {
              });
          })
        } else {
          this.modal.source.data = []
          this.modal.create = true;
          this.loading.create = false
          this.loading.edit = false
          this.loading.key = ""
        }
      })
    },
    handleMcreateClose() {
      this.modal.create = false;
    },
    handleMcreateOk() {
      this.formCreate.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        this.loading.savecreate = true

        if (this.modal.source.mode == "Create") {
          let data = new FormData();
          data.append("category", values.category.cost_pool_category_id);
          data.append("kode", values.code);
          data.append("nama", values.name);
          data.append("note", values.note ? values.note : "");

          this.asyncAxiosPost("akuntansi/master_cost_pool", "formdata", this.getAuth, data)
            .then(() => {
              this.loading.savecreate = false;
              this.formCreate.resetFields()
              this.modal.create = false;
              this.displayMessage("success-save")
              this.handleReloadpage()
            })
            .catch(() => {
              this.loading.savecreate = false;
            });
        } else {
          let paramdata = {
            cost_pool_id: this.modal.source.data.cost_pool_id,
            category: values.category.cost_pool_category_id,
            kode: values.code,
            nama: values.name,
            note: values.note ? values.note : ""
          }
          this.asyncAxiosPut("akuntansi/master_cost_pool", "application/json", this.getAuth, paramdata)
            .then(() => {
              this.loading.savecreate = false;
              this.formCreate.resetFields()
              this.modal.create = false;
              this.displayMessage("success-edit")
              this.handleReloadpage()
            })
            .catch(() => {
              this.loading.savecreate = false;
            });
        }
      })
    },
    handletoDel(id) {
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.delete = true;
          that.loading.key = id;
          that.asyncAxiosDelete(
            "akuntansi/master_cost_pool",
            "application/json",
            that.getAuth,
            { cost_pool_id: id }
          )
            .then((response) => {
              that.loading.delete = false;
              that.loading.key = "";
              if (response.status && response.status == true) {
                that.displayMessageValue("success-other", response.message);
              } else {
                let responses = Object.assign({}, response);
                that.displayMessageValue("error-other", responses);
              }
              that.handleReloadpage()
            })
            .catch(() => {
            });
        },
        onCancel() { },
      });
    },
    handleTab() {

    },
    inputVselect(item) {
      this.modal.source.category = "nonTLC"
      if (item.cost_pool_category_nm == 'TLC')
        this.modal.source.category = "TLC"

      this.$nextTick(function () {
        this.formCreate.setFieldsValue({
          code2: item.cost_pool_category_code,
          category: item
        });
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  }
}
</script>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead .ant-table-row-cell-break-word {
  text-align: center !important;
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border: 1px solid darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &-pertabs {
    height: 30px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border: 1px solid darken(white, 10);
    padding: @padding;
    color: darken(red, 10) !important;
  }
}

.snonaktif {
  color: red
}

.saktif {
  color: green
}

.hiddenOverflow {
  .vs__selected-options {
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
